import { render, staticRenderFns } from "./Hclist.vue?vue&type=template&id=68d6bfba&scoped=true&"
import script from "./Hclist.vue?vue&type=script&lang=js&"
export * from "./Hclist.vue?vue&type=script&lang=js&"
import style0 from "./Hclist.vue?vue&type=style&index=0&id=68d6bfba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6bfba",
  null
  
)

export default component.exports